<script setup lang='ts'>
import { APP_ROUTER, imageTransform } from '@qctsw/common'
import { contentRemoveTags, timeFormat } from '@qctsw/utils'
import { logicPublishCompleteList } from '@/logic/complaint/publish'

const props = withDefaults(defineProps<{
  brandId: number
  seriesId: number
  provinceId: number
  cityId: number
}>(), {})

const {
  state,
  data,
  getData,
} = logicPublishCompleteList()

getData({ brandId: props.brandId, seriesId: props.seriesId, provinceId: props.provinceId, cityId: props.cityId })
</script>

<template>
  <div>
    <UtilLoadState :state="state" :reload-handler="() => getData({ brandId, seriesId, provinceId, cityId })">
      <div v-for="v, i in data" :key="i">
        <template v-if="v.list.length">
          <BasicTitle :title="`${v.title}相关投诉`" class="mt-6 mb-sm" />
          <div class="grid grid-cols-2 gap-x-sm gap-y-3">
            <NuxtLink
              v-for="item, index in v.list"
              :key="index" :to="APP_ROUTER.complaintDetail(item.id)"
              :title="item.title"
              class="flex"
            >
              <img
                v-if="item.imgUrl"
                loading="lazy"
                :src="imageTransform(item.imgUrl, { width: 154, height: 106 })"
                :alt="item.title"
                class="w-38 h-24 object-cover rounded overflow-hidden flex-shrink-0 mr-sm"
              >
              <span class="flex-grow min-w-0 inline-flex flex-col justify-between">
                <span>
                  <span class="line-clamp-1 hover:text-orange-6">
                    <UtilComplaintStatus v-if="!isNaN(Number(item.complainStatusCode))" :code="Number(item.complainStatusCode)" />
                    <span class="font-bold">{{ item.title }}</span>
                  </span>
                  <span class="line-clamp-2 mt-1 text-3.5">
                    {{ contentRemoveTags(item.complainContent) }}
                  </span>
                </span>
                <UtilContentTips :tips-data="{ date: (item.createTime), favorCount: item.goodCount || 0 }" />
              </span>
            </NuxtLink>
          </div>
        </template>
      </div>
    </UtilLoadState>
  </div>
</template>

<style lang='scss' scoped>

</style>
